export default __webpack_public_path__ + "static/media/college.regular.b43ef64b.ttf";